import Cookies from 'js-cookie';
import { UserRole } from './authService';

interface UserData {
    id: string;
    username: string;
    roles: UserRole[]; // Changed from single role to array of roles
}

interface AuthToken {
    access_token: string;
    token_type: string;
}

interface PasswordExpiryData {
    password_expired: boolean;
    password_expiry_date: string;
    dialog_shown: boolean; // Flag to track if dialog has been shown
}

const COOKIE_OPTIONS = {
    expires: 7, // 7 days
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'strict' as const,
};

export const storageService = {
    // Token management with cookies
    setToken: (token: AuthToken) => {
        Cookies.set('auth_token', JSON.stringify(token), COOKIE_OPTIONS);
    },

    getToken: (): AuthToken | null => {
        const token = Cookies.get('auth_token');
        return token ? JSON.parse(token) : null;
    },

    // User data management with localStorage
    setUser: (user: UserData) => {
        localStorage.setItem('user_data', JSON.stringify(user));
    },

    getUser: (): UserData | null => {
        const userData = localStorage.getItem('user_data');
        return userData ? JSON.parse(userData) : null;
    },

    // Password expiry management
    setPasswordExpiry: (expiryData: PasswordExpiryData) => {
        localStorage.setItem('password_expiry', JSON.stringify(expiryData));
    },

    getPasswordExpiry: (): PasswordExpiryData | null => {
        const expiryData = localStorage.getItem('password_expiry');
        return expiryData ? JSON.parse(expiryData) : null;
    },

    // Clear all auth data
    clearAuth: () => {
        Cookies.remove('auth_token');
        localStorage.removeItem('user_data');
        localStorage.removeItem('password_expiry');
    },

    // Check if user is authenticated
    isAuthenticated: (): boolean => {
        return !!Cookies.get('auth_token');
    },
};
